// NPM
import React, { useState } from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { isNull, omitBy } from "lodash";

// UTILITY
import errorHandler from "Utils/error-handler";


// STYLE
import "../modal-forms/modal-forms.scss";

// ANT COMPONENTS
import { AlertBox, Button, DateRange } from "@life-line-lab/components-react";
import { Col, Row } from "antd";
import { WarningOutlined } from "@ant-design/icons";
import ModuleTitleBar from "Components/shared/module-title-bar/module-title-bar";

interface ConfirmModalProps {
    onSubmit: any;
    onCancel: any;
    contentWord?: string;
    info?:any;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({ 
    onSubmit,
    onCancel,
    contentWord,
    info,
}) => {
    const { t } = useTranslation();

    return (
        <div className="modal-forms--restore-version">
            <Row>
                <Col className="mb-0">
                </Col>
                <Col className="mb-0">
                    <ModuleTitleBar titleText={t("title.confirm")} haveSubtitle={false} />
                </Col>
            </Row>
            <Row>
                <Col className="mb-0">
                    <p>{contentWord}</p>
                </Col>
            </Row>
            
            <Row className="mt-20 right">
                <Col className="mb-0">
                    <Button
                        type="primary"
                        label={t("action.confirm")}
                        size="large"
                        onClick={()=>{onSubmit()}}
                    />
                    <Button
                        className="btn-cancel"
                        type="secondary"
                        size="large"
                        label={t("action.cancel")}
                        onClick={() => { onCancel()}}
                    />
                </Col>
            </Row>
        </div>
    );
};

export default ConfirmModal;
